/**
 * Pilatix About — reveal on scroll + stat count-up.
 * File: pltx2-about.js
 */
(function () {
  'use strict';

  /* ───── Reveal on scroll ───── */
  function initReveal() {
    var els = document.querySelectorAll('.pltx2-about [data-reveal]');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* ───── Stat count-up ───── */
  function initCountUp() {
    var stats = document.querySelectorAll('.pltx2-about-stat__num[data-count]');
    if (!stats.length) return;

    if (!('IntersectionObserver' in window)) {
      stats.forEach(function (el) {
        el.textContent = formatNum(el.getAttribute('data-count'), el);
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animate(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    stats.forEach(function (el) { observer.observe(el); });

    function animate(el) {
      var target = parseFloat(el.getAttribute('data-count'));
      if (isNaN(target)) {
        el.textContent = el.getAttribute('data-count');
        return;
      }
      var suffix = el.getAttribute('data-suffix') || '';
      var prefix = el.getAttribute('data-prefix') || '';
      var duration = 1400;
      var start = performance.now();

      function tick(now) {
        var progress = Math.min(1, (now - start) / duration);
        var eased = 1 - Math.pow(1 - progress, 3);
        var current = target * eased;
        var display = target % 1 === 0 ? Math.round(current) : current.toFixed(1);
        el.textContent = prefix + display.toLocaleString('he-IL') + suffix;
        if (progress < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    function formatNum(v, el) {
      var suffix = el.getAttribute('data-suffix') || '';
      var prefix = el.getAttribute('data-prefix') || '';
      return prefix + v + suffix;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReveal();
      initCountUp();
    });
  } else {
    initReveal();
    initCountUp();
  }
})();

/* PLTX2: Apple-like fade-in as images lazy-load (cached images resolve instantly). */
(function () {
  var roots = document.querySelectorAll('.pltx2-about');
  if (!roots.length) return;
  roots.forEach(function (root) { root.classList.add('pltx2-imgfx'); });
  document.querySelectorAll('.pltx2-about img').forEach(function (img) {
    var done = function () { img.classList.add('pltx2-img-loaded'); };
    if (img.complete && img.naturalWidth > 0) {
      done();
    } else {
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    }
  });
})();
